export default "__VITE_ASSET__VTb_TvCi__"